<div class="smooth-scrolling">

  <app-responsive-searchbar-black-border></app-responsive-searchbar-black-border>

  <!-- today offer title start -->

  <div class="offer-title">
    <h3><i>Today's </i><b>Offers</b></h3>
  </div>

  <!-- today offer title end -->

  <!-- upto offer section start -->

  <section class="upto-offer-section">
    <div class="mx-1035">
      <div class="row justify-content-center">
        <div class="col-lg-4 mt-lg-0 col-md-6 mt-4">
          <div class="upto-offer-content offer-shape-one">
            <span><small>UP to</small>25% OFF</span>
            <div class="upto-offer-image">
              <img src="assets/images/upto-offer-image-1.png" alt="image" />
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-lg-0 col-md-6 mt-4">
          <div class="upto-offer-content offer-shape-two">
            <span><small>UP to</small>35% OFF</span>
            <div class="upto-offer-image">
              <img src="assets/images/upto-offer-image-2.png" alt="image" />
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-lg-0 col-md-6 mt-4">
          <div class="upto-offer-content offer-shape-three">
            <span><small>UP to</small>45% OFF</span>
            <div class="upto-offer-image">
              <img src="assets/images/upto-offer-image-3.png" alt="image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- upto offer section end -->

  <!-- festival offer section start -->

  <section class="festival-offer-section">
    <div class="festival-image" style="background-image: url(assets/images/festival-image.png);">
      <div class="festival-title">
        <h4>festive offers</h4>
      </div>
    </div>
  </section>

  <!-- festival offer section end -->

  <!-- discount offer section start -->

  <section class="discount-offer-title-section">
    <div class="discout-offer-title">
      <h4><i>Excited</i> discounts <span>on</span> <b>brands</b></h4>
    </div>
  </section>

  <section class="discount-offer-slider">
    <owl-carousel-o [options]="dOfferSlider">
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-1.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-2.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-3.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-4.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-5.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-3.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-1.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="d-offer-content">
          <span><img src="assets/images/d-offer-image-2.png" alt="image" /></span>
          <div class="d-offer-image-content">
            <h4>Brand name</h4>
            <div class="d-offer-text">25% off</div>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>

    <div class="mt-lg-5">
      <owl-carousel-o [options]="dOfferSlider">
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-1.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-2.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-3.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-4.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-5.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-4.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-1.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="d-offer-content">
            <span><img src="assets/images/d-offer-image-2.png" alt="image" /></span>
            <div class="d-offer-image-content">
              <h4>Brand name</h4>
              <div class="d-offer-text">25% off</div>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </section>

  <!-- discount offer section end -->

  <!-- kits and bundles title start -->

  <div class="kits-title">
    <h3><i>kits & bundles </i><b>for less</b></h3>
  </div>

  <!-- kits and bundles title end -->

  <!-- kit offer section start -->

  <section class="kit-image-section">
    <div class="mx-1440">
      <div class="row">
        <div class="col-lg-4">
          <div class="kit-image-content-one">
            <span>
              <img src="assets/images/kit-image-content-one.png" alt="">
            </span>
            <strong>Bestseller combo</strong>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-md-6">
              <div class="kit-image-content-two">
                <span>
                  <img src="assets/images/kit-image-content-two.png" alt="">
                </span>
                <strong><i>flat</i> 10% off </strong>
              </div>
            </div>
            <div class="col-md-6">
              <div class="kit-image-content-three">
                <span>
                  <img src="assets/images/kit-image-content-three.png" alt="">
                </span>
                <strong><i>flat</i> 10% off </strong>
              </div>
            </div>
            <div class="col-12">
              <div class="kit-image-content-four">
                <span>
                  <img src="assets/images/kit-image-content-four.png" alt="">
                </span>
                <strong><i>flat</i> 15% off </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- kit offer section end -->

  <!-- today influencer section start -->

  <section class="today-influencer-section">
    <div class="row align-items-center">
      <div class="col-lg-3">
        <div class="today-influencer-title">
          <h4>influencer</h4>
          <span><i>favourite deals</i></span>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="row">
          <div class="col-md-6">
            <div class="influencer-offer-image">
              <div class="i-offer-image-1">
                <span><img src="assets/images/today-influencer-image-1.png" alt="image" /></span>
              </div>
              <div class="offer-influencer-text"><i>flat </i><b>15%</b></div>
              <div class="i-offer-image-2">
                <span><img src="assets/images/today-influencer-image-2.png" alt="image" /></span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="influencer-offer-image">
              <div class="i-offer-image-3">
                <span><img src="assets/images/today-influencer-image-3.png" alt="image" /></span>
              </div>
              <div class="offer-influencer-text offer-influencer-text-bottom"><i>Up to </i><b>10%</b></div>
              <div class="i-offer-image-4">
                <span><img src="assets/images/today-influencer-image-4.png" alt="image" /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- today influencer section end -->

  <!-- sale section start -->

  <section class="sale-section">
    <owl-carousel-o [options]="saleSlider">
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>LUX</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>k-Beauty</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>made in india</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>face tools</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>wellness</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>makeup</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>LUX</b>Sale</span>
        </div>
      </ng-template>
      <ng-template carouselSlide>
        <div class="sale-content">
          <span><b>k-Beauty</b>Sale</span>
        </div>
      </ng-template>
    </owl-carousel-o>
  </section>

  <!-- sale section end -->

  <!-- Footer START -->

  <app-footer-bg></app-footer-bg>

  <!-- Footer END -->
</div>